import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router';
import { ROUTES } from '../constants/RouteNameMapping';
import { ViewTypeByData } from '../data-models/view-config.data-model';

interface PortfolioRouteListenerOptions {
  onEnter?: () => void;
  onExit?: () => void;
  onRouteChange?: (isPortfolioRoute: boolean, pathname: string) => void;
  enabled?: boolean;
  viewType?: ViewTypeByData;
}

export function usePortfolioRouteListener(options?: PortfolioRouteListenerOptions) {
  const { pathname } = useLocation();
  const { onEnter, onExit, onRouteChange, enabled = true, viewType } = options || {};

  // Check if current route is a portfolio route
  const isPortfolioRoute = pathname.startsWith(`/${ROUTES.PORTFOLIO}`);

  // Handle route change callbacks
  const handleRouteChange = useCallback(
    (isPortfolio: boolean) => {
      if (!enabled) {
        return;
      }

      // Execute general route change callback
      if (onRouteChange) {
        onRouteChange(isPortfolio, pathname);
      }

      // Execute specific enter/exit callbacks
      if (isPortfolio && onEnter) {
        onEnter();
      } else if ((!isPortfolio || viewType !== ViewTypeByData.company) && onExit) {
        onExit();
      }
    },
    [enabled, onEnter, onExit, onRouteChange, pathname, viewType]
  );

  // Listen for route changes
  useEffect(() => {
    handleRouteChange(isPortfolioRoute);
  }, [isPortfolioRoute, handleRouteChange]);

  return {
    isPortfolioRoute,
    pathname,
    portfolioViewId: isPortfolioRoute ? pathname.split('/')[2] : null,
  };
}
